var ipp = document.querySelectorAll(".ipp")
var hqip = ipp[0].querySelector(".ip")
var ipCon = ipp[0].querySelector(".ip-con")
var ipWc = ipp[0].querySelectorAll(".ip-wc")
var ipName = ipp[0].querySelectorAll(".ip-name")
var ipSpan = ipp[0].querySelectorAll('.ip-span')
var flages = true

hqip.onclick = function (e) {
  e.stopPropagation()
  if (flages) {
    ipCon.style.display = "block"
    ipWc.forEach((item) => {
      var aLink = item.querySelector('a');
      aLink.setAttribute('target', '_self');
    })
    
    setTimeout(() => {
      ipCon.style.opacity = "1"
      flages = false
    })
  } else {
    ipCon.style.opacity = "0"
    setTimeout(() => {
      ipCon.style.display = "none"
      flages = true
    }, 300)

  }
}

document.body.onclick = function () {
  ipCon.style.opacity = "0"
  setTimeout(() => {
    ipCon.style.display = "none"
    flages = true
  }, 300)

}